import CommonButton from "../common11/Buttons/CommonButton";

/** Single-line filter row with Reset / Search aligned to the right (OT modals). */
function OtModalFilterRow({ children, onReset, onSubmit }) {
  return (
    <form
      onSubmit={onSubmit}
      className="rounded-lg border border-gray-200 p-3"
      onReset={(e) => {
        e.preventDefault();
        onReset?.();
      }}
    >
      <div className="flex flex-wrap items-end gap-2">
        {children}
        <div className="flex items-center gap-2 ml-auto shrink-0 pb-0.5">
          <CommonButton
            label="Reset"
            type="button"
            variant="danger-outline"
            size="sm"
            onClick={onReset}
          />
          <CommonButton label="Search" type="submit" variant="primary-filled" size="sm" />
        </div>
      </div>
    </form>
  );
}

export default OtModalFilterRow;
